export default "__VITE_ASSET__DQtNLyP5__"